// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DiscoveryContentTypeOriginSchema = z.enum(['DEFAULT','CUSTOM'] as const);

export type DiscoveryContentTypeOriginType = `${z.infer<typeof DiscoveryContentTypeOriginSchema>}`

export default DiscoveryContentTypeOriginSchema;
